export function isImageByFilename(fileName: string): boolean {
  const extension = fileName.split('.').pop();

  if (!extension) {
    throw new Error(
      `Unable to determine file type: invalid file name: ${fileName}.`,
    );
  }

  const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'];

  return imageExtensions.includes(extension.toLowerCase());
}
